export default __webpack_public_path__ + "static/media/cp_geo_ug.463f178d.svg";